<template>
  <div class="row">
    <div class="col-12">

      <div class="new-button-div">
        <router-link :to="{ name: 'Nueva Familia de Productos' }" class="col-2">
          <n-button type="primary" round>
            <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
            {{ $t("app.buttons.new") }}
          </n-button>
        </router-link>
      </div>

      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">

            <h4 class="card-title text-purple">{{ $t("app.modules.product_family.title") }}</h4>

            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px;"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables">
              </el-input>
            </fg-input>

          </div>

          <el-table stripe style="width: 100%;" :data="queriedData">

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :minWidth="column.minWidth"
              :prop="column.prop"
              :label="$t(column.label)"
              :className="column.className"
              sortable
            >
            </el-table-column>

            <el-table-column
              className="is-center"
              labelClassName="is-center"
              :label="$t('app.modules.product_family.headers.enriched')"
              minWidth="160"
            >
              <template slot-scope="scope">

                <i v-if="scope.row.enriquecido" class="fa fa-check indicator success"></i>
                <i v-else class="fa fa-times indicator danger"></i>

              </template>
            </el-table-column>

            <el-table-column
              className="is-center"
              labelClassName="is-center"
              :label="$t('app.modules.product_family.headers.published')"
              minWidth="150"
            >
              <template slot-scope="scope">

                <i v-if="scope.row.publicado" class="fa fa-check indicator success"></i>
                <i v-else class="fa fa-times indicator danger"></i>

              </template>
            </el-table-column>

            <el-table-column
              :minWidth="200"
              fixed="right"
              className="is-center"
              labelClassName="is-center">

              <div slot-scope="scope" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                >

                  <div class="row">
                    <div class="col-12 options">

                      <router-link :to="{ name: 'Nueva Familia de Productos', params: { id: scope.row.idFamiliaProducto } }">
                        <n-button
                          class="options-button"
                          type="primary"
                          size="sm">
                          {{ $t('app.modules.product_family.buttons.enriched') }}
                        </n-button>
                      </router-link>

                      <!--<n-button
                        class="options-button"
                        type="primary"
                        size="sm">
                        {{ $t('app.modules.product_family.buttons.enriched') }}
                      </n-button>-->

                      <n-button v-if="scope.row.publicado"
                                class="options-button"
                                type="default"
                                round
                                @click.native="unpublish(scope.row)"
                                size="sm">
                        {{ $t('app.modules.product_family.buttons.unpublish') }}
                      </n-button>
                      <n-button v-else
                                class="options-button"
                                type="primary"
                                round
                                @click.native="publish(scope.row)"
                                size="sm">
                        {{ $t('app.modules.product_family.buttons.publish') }}
                      </n-button>
                    </div>
                  </div>

                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    style="background-color:white;">
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>

                </el-popover>
              </div>
            </el-table-column>
          </el-table>

        </div>

        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }} {{ $t("app.pagination.of") }} {{ to }} {{ $t("app.pagination.of") }} {{ total }} {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total">
          </n-pagination>
        </div>
      </card>


    </div>
  </div>
</template>

<script>
import { Pagination as NPagination } from "src/components";
import {mapState} from "vuex";
import {getResponse} from "@/util/utilities";
import Fuse from "fuse.js";

export default {

  components: {
    NPagination
  },
  computed: {
    ...mapState(["user"]),
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["nombreFamilia"],
      tableColumns: [
        {
          prop: "productoPadre",
          label: "app.modules.product_family.headers.name",
          minWidth: 250
        },
        /*{
          prop: "categoriaProducto.nombreCategoria",
          label: "app.modules.product_family.headers.category_name",
          minWidth: 180
        },
        {
          prop: "subcategoriaProducto.nombreSubcategoria",
          label: "app.modules.product_family.headers.subcategory_name",
          minWidth: 180
        },*/
        {
          prop: "fechaUltimaModificacion",
          label: "app.modules.product_family.headers.last_modification",
          minWidth: 220,
          className: "is-center"
        }
      ],
      tableData: [],
      searchedData: []
    };
  },
  methods: {
    async searchAgain() {
      const options = {
        keys: ["productoPadre"],
        threshold: 0.3,
        shouldSort: false
      };
      let fuseSearch = new Fuse(this.tableData, options);
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = fuseSearch
          .search(this.searchQuery)
          .map(result => result.item);
      }
      this.searchedData = result;
    },
    async init() {
      let self = this;
      this.$swal.fire({
        title: self.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };

      await
        this.$http
          .get(route("FamiliasProducto/getFamiliasProducto"), payload)
          .then (
            async response => {
              if(response.body.code === 200){
                this.tableData = response.body.familiasProductos;
              }else {
                this.notifyMessage("danger", self.$t("app.promps.error"));
              }
            },
            error => {
              this.notifyMessage("danger", self.$t("app.promps.error"));
            }
          );

      this.$swal.close();
    },
    async publish(entity){
      entity.publicado = true;
      entity.usuarios_idUsuario = this.user.idUsuario;

      let request = await this.$http.put(route("FamiliasProducto/publish"), entity);
      let response = getResponse(request, null);

      if(response) this.notifyMessage("success", this.$t("app.promps.save_success"));
      else{
        this.notifyMessage("danger", this.$t("app.promps.error"));
        entity.publicado = false;
      }

    },
    async unpublish(entity){
      entity.publicado = false;
      entity.usuarios_idUsuario = this.user.idUsuario;

      let request = await this.$http.put(route("FamiliasProducto/publish"), entity);
      let response = getResponse(request, null);

      if(response) this.notifyMessage("success", this.$t("app.promps.save_success"));
      else{
        this.notifyMessage("danger", this.$t("app.promps.error"));
        entity.publicado = true;
      }

    }
  },
  mounted() {
    this.init();
  },
  watch: {
    searchQuery(value) {
      this.searchAgain();
    }
  }
}
</script>

<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
.like {
  margin: 0 5px 0 5px !important;
}
.indicator {
  font-size: 30px;
}
.indicator.success {
  color: #18ce0f;
}
.indicator.danger {
  color: #ff3636;
}
</style>
